"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpRequest = void 0;
const generateHeaders_1 = require("./generateHeaders");
const httpConsts_1 = require("./httpConsts");
const httpRequest = (req, headerParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { config, urlSuffix, body } = req;
    const { method, baseUrl = "", type, retryCount = 0, keepAlive, image, } = config;
    const assetBaseUrl = httpConsts_1.envToAssetUrl[headerParams.env];
    const url = type === httpConsts_1.RequestType.EXTERNAL
        ? `${assetBaseUrl}${urlSuffix}`
        : `${baseUrl}${urlSuffix}`;
    const headers = (0, generateHeaders_1.generateHeaders)(Object.assign({ req, url }, headerParams));
    for (let attempt = 0; attempt <= retryCount; attempt++) {
        try {
            const res = yield fetch(url, {
                headers,
                method,
                keepalive: keepAlive,
                body: JSON.stringify(body),
            });
            const data = image
                ? URL.createObjectURL(yield res.blob())
                : yield res.json();
            return { status: res.status, message: res.statusText, data };
        }
        catch (error) {
            if (attempt === retryCount) {
                throw new Error(`Request failed after ${retryCount + 1} attempts`);
            }
        }
    }
    throw new Error("All attempts to make the HTTP request failed");
});
exports.httpRequest = httpRequest;
